module.exports = __webpack_public_path__ + "img/0Q3A5746_L_BlackMatted.373edc0c.jpg";